import { Address } from '@/types'
import { TFunction, useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import Link from 'next/link'
import { getLocalizedText } from '@/lib/constants/locales'

const ExperienceAddressCard = ({
  address,
  t,
}: {
  address: Address
  t: TFunction
}) => {
  const router = useRouter()
  const { i18n } = useTranslation()
  // Defensive guard (DEV-796): address can be null at runtime.
  if (!address) return null
  const locale = router.locale ?? i18n?.language ?? 'en'
  const label =
    address.formattedAddress || getLocalizedText(address.name, locale) || null

  return (
    <>
      {label && <div>{label}</div>}

      <Link
        href={`https://www.google.com/maps?q=${address.latitude},${address.longitude}`}
        className="font-semibold"
        target="_blank"
      >
        {t('open_in_maps')}
      </Link>
    </>
  )
}

export default ExperienceAddressCard
